import getEnlightenConfig from '../Config/envEnlighten'

class Urls {
  constructor(config) {
    this.config = config
  }

  getApiUrl(url) {
    return `${this.config.api}/${url}`
  }
}

export default new Urls(getEnlightenConfig(process.env.NODE_ENV))
